module.exports = __webpack_public_path__ + "static/img/map3-bg.12ba473.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/map3-bg.png
// module id = XXjl
// module chunks = 0